// main.js
// turn48-final: source-level patch integration (turn21-47 27 改动)
import { createApp } from 'vue'
import './style.css'
import './styles/tactical-tokens.css'  // ADR-WEB-12.46 PR4: tactical HUD theme (route-scoped via .tactical class)
import './assets/trace-craft.css'      // BL142 CRAFT-1: maple craft 节奏变量 (--tm-*, trace 域消费)
// turn46 html bg + turn27-47 appshell + turn41 dashboard (CSS as source)
import App from './App.vue'
import router from './router/index.js'

;(function preFetchRouteChunk() {
  const p = window.location.pathname
  if (p === '/login' || p.startsWith('/login')) { import('./pages/Login.vue'); return }
  if (p === '/' || p === '') {
    import('./layouts/AppShell.vue')
    import('./pages/Dashboard.vue')
    return
  }
  if (p.startsWith('/pnl'))       import('./pages/Pnl.vue')
  if (p.startsWith('/positions')) import('./pages/Positions.vue')
  if (p.startsWith('/changelog')) import('./pages/Changelog.vue')
})()

const app = createApp(App)
app.use(router)
app.mount('#app')
